var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{class:("md-raised we-button size-" + _vm.size + " outline-" + _vm.outline),attrs:{"to":_vm.to},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }